import React from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { DepositStore } from "@state/stores/payment/deposit";
import useCurrency from "@state/hooks/shared/useCurrency";
import { NavLink } from "react-router-dom";
import { getCurrentCulture } from "@utils";
import { formatDateTime } from "@utils/offer";
import { useFixBody } from "@state/hooks/shared";

export default observer(function LugasLimitExcededPopup(props: {
	store: DepositStore;
}) {
	const { t } = useTranslation([
		"account-verification",
		"account-settings-navigation",
	]);

	useFixBody(true, !!props.store.limitExcededInfo);

	const { currency } = useCurrency();

	if (!props.store.limitExcededInfo) {
		return null;
	}

	return (
		<div className="popup">
			<div className="popup__card popup__card--big">
				<div className="popup__header">
					{t("account-settings-navigation:MY_LIMITS")}
				</div>
				<div className="popup__body">
					<div>
						{t("DEPOSIT.LUGAS_LIMIT.CROSS_LIMIT_REACHED", {
							interpolation: { escapeValue: false },
							0: props.store.limitExcededInfo.limitRequestValue,
							1: currency,
							2: formatDateTime(
								props.store.limitExcededInfo.limitRequestDate
							),
						})}
					</div>
					{props.store.limitExcededInfo.showCreditRating && (
						<div>
							{t("LIMIT_INCREASE.LIMIT_INCREASE_NAVIGATION")}
						</div>
					)}

					{props.store.limitExcededInfo.showVerificationLink && (
						<div>{t("ACC_VERIFICATION_NAVIGATION")}</div>
					)}
				</div>
				<LugasLimitExcededPopupFooter store={props.store} />
			</div>
		</div>
	);
});

function LugasLimitExcededPopupFooter(props: { store: DepositStore }) {
	const { t } = useTranslation("account-verification");

	const closePopup = () => {
		props.store.setLimitExcededInfo(null);
	};

	if (
		props.store.limitExcededInfo?.showCreditRating ||
		props.store.limitExcededInfo?.showVerificationLink
	) {
		return (
			<div className="popup__footer">
				<>
					{props.store.limitExcededInfo.showCreditRating && (
						<NavLink
							className="popup__btn btn btn--med btn--primary"
							to={`/${getCurrentCulture()}/limit-increase`}
						>
							{t("LIMIT_INCREASE.TITLE")}
						</NavLink>
					)}

					{props.store.limitExcededInfo.showVerificationLink && (
						<NavLink
							className="popup__btn btn btn--med btn--primary"
							to={`/${getCurrentCulture()}/account-settings/account-verification`}
						>
							{t("TITLE")}
						</NavLink>
					)}
				</>
			</div>
		);
	}

	return (
		<div className="popup__footer">
			<button
				onClick={closePopup}
				className="popup__btn btn btn--med btn--primary"
				type="button"
			>
				{t("SESSION.AUTO_LOGOUT.BUTTON_OK")}
			</button>
		</div>
	);
}
